var map = {
	"./ask": [
		94991,
		4991
	],
	"./ask.ts": [
		94991,
		4991
	],
	"./goal": [
		17161,
		7161
	],
	"./goal.ts": [
		17161,
		7161
	],
	"./objective": [
		90908,
		908
	],
	"./objective.ts": [
		90908,
		908
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 46622;
module.exports = webpackAsyncContext;